module.exports = __webpack_public_path__ + "static/media/hoItWorks.c1621d92.png";